import { gql } from "@/gql/__generated__";
import { Update_User_RoleMutation } from "@/gql/__generated__/graphql";
import { useMutation } from "@apollo/client";

const UPDATE_USER_ROLE = gql(`
    mutation UPDATE_USER_ROLE($organizationId: ID!, $userId: ID!, $role: Role!) {
        organizationMemberEditRole(
            input: {userId: $userId, role: $role},
            organizationId:  $organizationId
        ) {
            ... on OrganizationMembership {
              id
              role
            }
            ... on OrganizationNotFound {
                id
            }
            ... on UserNotFound {
                id
            }
        }
    }
`);

export const useUpdateUserRole = (memberId: string) =>
  useMutation(UPDATE_USER_ROLE, {
    optimisticResponse: (vars) =>
      ({
        organizationMemberEditRole: {
          __typename: "OrganizationMembership",
          id: memberId,
          role: vars.role
        }
      }) as Update_User_RoleMutation
  });
